<div class="modal-header noselect">
  <h2 class="modal-title">Contact Us</h2>
  <button type="button" class="btn-close" (click)="onCancelled()" [disabled]="form.isSubmitting"></button>
</div>

<div class="modal-body">
  <app-contact-form
    #form
    [showCancel]="true"
    (submitted)="onSubmitted()"
    (cancelled)="onCancelled()"
  ></app-contact-form>
</div>
